module.exports = __webpack_public_path__ + "img/n03.66320b38.png";